module.exports = __webpack_public_path__ + "img/globe.d1ab8bcb.svg";